export const APP_SEMVER = "1.0.0";

declare const __APP_VERSION__: string;

export const APP_BUILD = import.meta.env.DEV ? "dev" : __APP_VERSION__;
export const APP_VERSION_STRING = `v${APP_SEMVER}+${APP_BUILD}`;
